import { apiRequest } from ".";

export const handleClientCSVRequest = (data) => {
	return apiRequest(
		'/admin/imports/client',
		{
			method: 'POST',
			body: JSON.stringify(data)
		}
	)
}

export const handlePaymentCSVRequest = (data) => {
	return apiRequest(
		'/admin/imports/payment',
		{
			method: 'POST',
			body: JSON.stringify(data)
		}
	)
}

export const handleUnitCSVRequest = (data) => {
	return apiRequest(
		'/admin/imports/unit',
		{
			method: 'POST',
			body: JSON.stringify(data)
		}
	)
}